import { useAppDispatch, useAppSelector } from '../../hooks';
import { useGetPageTextsQuery } from './partyApplicationApi';
import { ApplicationSteps } from '../../types/PartyApplication/partyApplication';
import FormPage from './pages/FormPage';
import ConfirmationPage from './pages/ConfirmationPage';
import ExistingBankruptcyConfirmationPage from './pages/ExistingBankruptcyConfirmationPage';
import styles from './PartyApplication.module.scss';
import tslLogoBlack from '../../images/tsl-logo-black.svg';
import classNames from 'classnames';
import { useEffect } from 'react';
import { setPageTexts } from '../../redux/reducer/partyApplicationSlice';
import Skeleton from 'components/formComponents/Layout/Skeleton';
import TextBlock from 'components/formComponents/Base/TextBlock';
import FormBlock from 'components/formComponents/Layout/FormBlock';
import { useGetReactConfigQuery } from '../../configApi';
import { Helmet } from 'react-helmet-async';

const PartyApplication = () => {
  const dispatch = useAppDispatch();
  const { currentStep } = useAppSelector((state) => state.partyApplication);
  const { data, isLoading, error } = useGetPageTextsQuery();
  const { data: reactConfig, isLoading: isLoadingReactConfig } =
    useGetReactConfigQuery();
  const cookieBotId = reactConfig?.cookieBotId;
  const getActiveStep = () => {
    switch (currentStep) {
      case ApplicationSteps.Form:
        return <FormPage />;
      case ApplicationSteps.Confirmation:
        return <ConfirmationPage />;
      case ApplicationSteps.ExistingBankruptcyConfirmation:
        return <ExistingBankruptcyConfirmationPage />;
      default:
        return <FormPage />;
    }
  };

  useEffect(() => {
    if (data) {
      dispatch(setPageTexts(data));
    }
  }, [data, dispatch]);

  const branding = (
    <div className={styles.branding}>
      <a href="https://www.tsl.se/" target="_blank" rel="noopener noreferrer">
        <img className={styles.logo} src={tslLogoBlack} alt="TSL logga" />
      </a>
    </div>
  );

  return (
    <>
      <Helmet>
        {cookieBotId && (
          <>
            <style type="text/css">
              {`
                a#CybotCookiebotDialogPoweredbyCybot,
                div#CybotCookiebotDialogPoweredByText {
                  display: none !important;
                }

                #CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo {
                  display: none !important;
                }
              `}
            </style>
            <script
              id="Cookiebot"
              src="https://consent.cookiebot.com/uc.js"
              data-cbid={cookieBotId}
              data-blockingmode="auto"
              type="text/javascript"
            />
          </>
        )}
      </Helmet>
      <div className={styles.page}>
        {branding}
        <div
          className={classNames(styles.container, {
            [styles.containerFormWide]: currentStep === ApplicationSteps.Form,
            [styles.containerCentered]:
              currentStep === ApplicationSteps.Confirmation ||
              currentStep === ApplicationSteps.ExistingBankruptcyConfirmation,
          })}
        >
          {error ? (
            <FormBlock title="Ett fel uppstod">
              <TextBlock
                type="error"
                text="Sidinnehållet kunde inte hämtas. Försök igen
              senare."
              />
            </FormBlock>
          ) : isLoading || isLoadingReactConfig ? (
            <Skeleton />
          ) : (
            getActiveStep()
          )}
        </div>
      </div>
    </>
  );
};

export default PartyApplication;
